
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const FarmUploadInstructions: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Upload Instructions</CardTitle>
        <CardDescription>Follow these guidelines for successful uploads</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <h3 className="font-semibold mb-1">Required Fields</h3>
          <ul className="list-disc pl-5 space-y-1 text-sm">
            <li>Region - The geographical region of the farm</li>
            <li>Farm Size - The size of the land in hectares</li>
            <li>Farmer Name - The full name of the farmer</li>
            <li>Phone Number - Contact phone for the farmer</li>
            <li>Product Name - Main crop or product grown</li>
          </ul>
        </div>
        
        <div>
          <h3 className="font-semibold mb-1">Optional Fields</h3>
          <ul className="list-disc pl-5 space-y-1 text-sm">
            <li>Irrigation Type - The irrigation method used</li>
            <li>Latitude/Longitude - Geographic coordinates</li>
            <li>Union Name - Name of the farmer union, if applicable</li>
            <li>Has Contract - Whether the farmer has a contract (Yes/No)</li>
            <li>Has Phone Access - Whether the farmer has access to a phone (Yes/No)</li>
            <li>Officer - Field officer assigned to the farm</li>
            <li>Distance from Addis - Distance in kilometers</li>
            <li>Harvest Start Date - When harvesting is expected to begin (YYYY-MM-DD)</li>
            <li>Harvest End Date - When harvesting is expected to end (YYYY-MM-DD)</li>
            <li>Kebelle - Local administrative area</li>
            <li>Estimated Harvest (kg) - Expected harvest quantity in kilograms</li>
          </ul>
        </div>
        
        <div>
          <h3 className="font-semibold mb-1">Date Format Guidelines</h3>
          <p className="text-sm">
            All dates should be in the format YYYY-MM-DD (e.g., 2025-04-15). Excel sometimes stores dates as
            numbers - make sure to format date columns as text before entering dates.
          </p>
        </div>
        
        <div>
          <h3 className="font-semibold mb-1">Important Notes</h3>
          <ul className="list-disc pl-5 space-y-1 text-sm">
            <li>For each farm uploaded, an initial planned harvest record will be created</li>
            <li>The "Estimated Harvest (kg)" field will be used to set the expected quantity for harvests</li>
            <li>Excel file should have column headers in the first row</li>
            <li>Use the template for best results</li>
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};

export default FarmUploadInstructions;
